/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from 'utils/styles';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// LOADER : SILLY
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default {
	silly: {
        height: pxToEm(30),
        width: pxToEm(90),
        position: 'relative',
        '& .bar': {
            background: '#fff',
            height: '0',
            position: 'absolute',
            bottom: '0',
            width: pxToEm(10),
            borderRadius: pxToEm(2),
            '&:nth-child(1)': { left: pxToEm(0), animation: `bottom-top 2s infinite ease-in-out .2s` },
            '&:nth-child(2)': { left: pxToEm(15), animation: `bottom-top 2s infinite ease-in-out .4s` },
            '&:nth-child(3)': { left: pxToEm(30), animation: `bottom-top 2s infinite ease-in-out .6s` },
            '&:nth-child(4)': { left: pxToEm(45), animation: `bottom-top 2s infinite ease-in-out .8s` },
            '&:nth-child(5)': { left: pxToEm(60), animation: `bottom-top 2s infinite ease-in-out 1.0s` },
            '&:nth-child(6)': { left: pxToEm(75), animation: `bottom-top 2s infinite ease-in-out 1.2s` }
        }
    },
    [`@keyframes bottom-top`]: {
        '0%': { height: '0', opacity: '0' },
        '50%': { height: pxToEm(30), opacity: '1' },
        '100%': { height: '0', opacity: '0' }
    }
};